
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { TypedVue } from "@/store/types";
import { OrientationGroupV8 } from "./types";

@Component
export default class ElraReport8Orientations extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true }) orientationGroups!: OrientationGroupV8[];

  openOrientationIds: Set<string> = new Set();

  mounted() {
    const firstId = this.orientationGroups[0]?.id;
    if (firstId) this.openOrientationIds = new Set([firstId]);
  }

  onOrientClick(id: string, e: MouseEvent): void {
    if (e.shiftKey) {
      const next = new Set(this.openOrientationIds);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      this.openOrientationIds = next.size === 0 ? new Set([id]) : next;
    } else {
      this.openOrientationIds = new Set([id]);
    }
  }

  closeOrient(id: string): void {
    const next = new Set(this.openOrientationIds);
    next.delete(id);
    this.openOrientationIds = next;
  }

  expandedTraits: Record<string, boolean> = {};

  toggleTrait(traitKey: string): void {
    this.$set(this.expandedTraits, traitKey, !this.expandedTraits[traitKey]);
  }
}
